import { defineStore } from 'pinia';
import CryptoJS from 'crypto-js';
import {
  login as userLogin,
  logout as userLogout,
  getUserInfo,
  LoginData,
} from '@/api/user';
import { setToken, clearToken } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { UserState } from './types';
import useAppStore from '../app';

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    nickname: undefined,
    avatar: undefined,
    type: undefined,
    // organization: undefined,
    // location: undefined,
    // email: undefined,
    // introduction: undefined,
    // personalWebsite: undefined,
    // jobName: undefined,
    // organizationName: undefined,
    // locationName: undefined,
    // phone: undefined,
    // registrationDate: undefined,
    // accountId: undefined,
    // certification: undefined,
    roles: [],
  }),

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    switchRoles() {
      // return new Promise((resolve) => {
      //   this.roles = this.roles === 'user' ? 'admin' : 'user';
      //   resolve(this.roles);
      // });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      const { data } = await getUserInfo();
      this.setInfo(data);
    },

    // Login
    async login(loginForm: LoginData) {
      try {
        const md5Key = CryptoJS.MD5('fanxing-tech').toString();
        // unix时间戳(秒)
        const timestamp = Math.floor(Date.now() / 1000);
        const loginFormData = {
          phone: loginForm.phone,
          password: CryptoJS.MD5(loginForm.password).toString(),
          sign: CryptoJS.SHA256(`${md5Key}-${timestamp}`).toString(),
          timestamp,
        };
        const { data } = await userLogin(loginFormData);
        setToken(data.token);
        this.setInfo(data);
      } catch (err) {
        clearToken();
        throw err;
      }
    },
    logoutCallBack() {
      const appStore = useAppStore();
      this.resetInfo();
      clearToken();
      removeRouteListener();
      appStore.clearServerMenu();
    },
    // Logout
    async logout() {
      try {
        await userLogout();
      } finally {
        this.logoutCallBack();
      }
    },
  },
});

export default useUserStore;
